import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { searchResultsExecutionStatus } from '@as-react/common-types';
import { Grid, Stack, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useProductListerContext } from './context/ProductListerContext';
import { ProductListerSEOText } from './ProductListerSEOText';
export const ProductListerHeading = () => {
    const { hideTitle, title, seoTextInclude, urlState, query: { data }, } = useProductListerContext();
    const { seo: { productListerSEOTextLocation }, } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const showSEOText = !!seoTextInclude && productListerSEOTextLocation === 'top' && seoTextInclude.trim().length > 0;
    const needsToRenderCategoryTitle = !!title && title !== '';
    const needsToRenderSearchTitle = urlState && !!urlState.q && urlState.q !== '';
    const needsToRenderChangedMisspellingTitle = (data === null || data === void 0 ? void 0 : data.executionStatus) === searchResultsExecutionStatus.ALT_SPELL_CHANGED;
    const needsToRenderATitle = needsToRenderCategoryTitle || needsToRenderSearchTitle || needsToRenderChangedMisspellingTitle;
    return (_jsxs(Stack, { direction: "col", gap: "3", children: [!hideTitle && needsToRenderATitle && (_jsx(TextAlpha, { variant: "headingM", as: "h1", children: needsToRenderCategoryTitle
                    ? title
                    : needsToRenderSearchTitle
                        ? t('product.lister.title.search', {
                            searchValue: urlState.q,
                        })
                        : '' })), showSEOText && (_jsx(Grid, { columns: 12, children: _jsx(Grid.Cell, { span: { base: 12, lg: 8, xl: 6 }, children: _jsx(ProductListerSEOText, {}) }) }))] }));
};
